<main
  id="wrapper-home"
  class="d-flex flex-column justify-content-center align-items-end"
>
  <section class="container-fluid">
    <div class="row">
      <div class="col-12 col-xl-6">
        <h1 class="mb-2">Nuestro sitio web actualmente</h1>
        <h5 class="mb-3">se encuentra en mantenimiento programado</h5>
        <h6>
          Estamos trabajando para restablecer nuevamente el servicio, lo antes
          posible
        </h6>
        <h6>Agradecemos tu compresión.</h6>
        <div
          class="d-flex flex-column flex-md-row align-items-center justify-content-around mt-5"
        >
          <img
            id="img_logo_1"
            src="./assets/img/Home/svg/Logo_neocredito_footer.svg"
            alt=""
            class="img-fluid"
          />
          <img
            id="img_logo_2"
            src="./assets/img/Home/svg/Logo_bancoldex.svg"
            alt=""
            class="img-fluid mt-5 mt-md-0"
          />
        </div>
      </div>
    </div>
  </section>
</main>
